import { GradientOverlay } from '@components/GradientOverlay/GradientOverlay';
import { SelectableCard } from '@components/SelectableCard/SelectableCard';
import { isCompactCell } from '@components/VirtualMasonry/masonryConstants';
import { calculateUploadStats } from '@pages/Library/utils/uploadCalculations';
import { FileUploadStatus } from '@stores/UploadManager/UploadManager';
import { observer } from 'mobx-react-lite';
import { StatusOverlay } from '../MediaCard/components/StatusOverlay';
import { Thumbnail } from '../MediaCard/components/Thumbnail';

interface VirtualUploadCardProps {
  status: FileUploadStatus;
  isVisible: boolean;
  cellWidth: number;
  onClear: () => void;
}

export const VirtualUploadCard = observer(function VirtualUploadCard({
  status,
  isVisible,
  cellWidth,
  onClear,
}: VirtualUploadCardProps) {
  const localThumbnail = status.localThumbnail;
  const isQueued = status.status === 'queued';

  return (
    <SelectableCard isSelected={false}>
      {isVisible && localThumbnail ? (
        <Thumbnail src={localThumbnail} localThumbnail={localThumbnail} />
      ) : (
        <Thumbnail alt={status.file.name} gradientSeed={status.fingerprint} />
      )}
      <GradientOverlay zIndex={2} borderRadius={14} />
      <GradientOverlay
        variant="bottom-blur"
        backdropBlur={20}
        height={20}
        zIndex={3}
        borderRadius={14}
      />
      {isQueued ? (
        <StatusOverlay
          type="queued-upload"
          title={status.file.name}
          duration={status.metadata?.duration as number | undefined}
          isCompact={isCompactCell(cellWidth)}
          closeButtonProps={{
            onClose: onClear,
            tooltip: 'Clear queued upload',
          }}
        />
      ) : (
        <StatusOverlay
          type="uploading"
          progress={Math.floor(status.progress)}
          title={status.file.name}
          duration={status.metadata?.duration as number | undefined}
          isCompact={isCompactCell(cellWidth)}
          timeLeft=""
          subtext={calculateUploadStats(status, status.progress).subtext}
          closeButtonProps={{
            onClose: onClear,
            tooltip: 'Clear upload',
          }}
        />
      )}
    </SelectableCard>
  );
});
